import { createAsyncThunk } from '@reduxjs/toolkit';
import { getBusinessCompetencyTypes } from '../services/getBusinessCompetencyTypes.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

export const loadBusinessCompetencyTypes = createAsyncThunk(
  'cards/loadBusinessCompetencyTypes',
  async (projectId, { getState }) => {
    // If a project id is provided, load competencies for that project's business.
    // Otherwise fall back to the currently selected project.
    const selectedProjectId = selectSelectedProjectId(getState());
    const effectiveProjectId = projectId || selectedProjectId;

    const response = await getBusinessCompetencyTypes(effectiveProjectId);

    return response;
  }
);
